require('../../modules/es6.number.parse-float');
module.exports = require('../../modules/_core').Number.parseFloat;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/parse-float.js
// module id = 1439
// module chunks = 1